"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCommonGlobalColors = void 0;
var fendt_1 = __importDefault(require("./fendt"));
var getCommonGlobalColors = function (brand) {
    return __assign({ grays: {
            50: '#FAFAFA',
            100: '#F5F5F5',
            200: '#EEEEEE',
            300: '#E0E0E0',
            400: '#BDBDBD',
            500: '#9E9E9E',
            600: '#757575',
            700: '#616161',
            800: '#424242',
            900: '#212121',
        }, success: {
            100: '#D9ECC5',
            500: '#81BF3E',
            900: '#266611',
        }, warning: {
            100: '#F3DCB2',
            500: '#DB9110',
            900: '#C15300',
        }, error: {
            100: '#FFCBD3',
            500: '#FF282F',
            900: '#CA0013',
        }, info: {
            100: '#BCDCFE',
            500: '#2E90FA',
            900: '#2640A6',
        } }, (brand === 'fendt' && fendt_1.default));
};
exports.getCommonGlobalColors = getCommonGlobalColors;
